module.exports = __webpack_public_path__ + "img/72.28836b2b.jpg";